import './App.css';
import Home from './component/Home';
// import Test from './component/Test';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <div className="container">
        <Home />
        {/* <BrowserRouter>
          <Routes><Route path="/test" element={<Test />} /></Routes>
        </BrowserRouter> */}
      </div>
    </div>
  );
}

export default App;
